import { render, staticRenderFns } from "./addVehicleMaintenance.vue?vue&type=template&id=20498136"
import script from "./addVehicleMaintenance.vue?vue&type=script&lang=js"
export * from "./addVehicleMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports